import { render, staticRenderFns } from "./caBreed.vue?vue&type=template&id=5114889f&scoped=true&"
import script from "./caBreed.vue?vue&type=script&lang=js&"
export * from "./caBreed.vue?vue&type=script&lang=js&"
import style0 from "./caBreed.vue?vue&type=style&index=0&id=5114889f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5114889f",
  null
  
)

export default component.exports